const swiper1 = new Swiper('.swiper1', {
  // Optional parameters
  direction: 'horizontal',
  loop: false,
  speed: 5000,
  spaceBetween: 10, // スライド間の距離
　centeredSlides: true,
　autoplay:{ 
	 delay : 2000,
},

  // If we need pagination
  pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
  slidesPerView: 1.5,
   breakpoints: {
     500: {
      slidesPerView: 2.5,
    }
   }
});

const swiper2 = new Swiper('.swiper2', {
  direction: 'horizontal',
  loop: false,
  loopAdditionalSlides: 2,
  speed: 1000,
  spaceBetween: 10,
  centeredSlides: true,
  autoplay: {
    delay: 5000,
  },
  slidesPerView: 1.15,
  pagination: {
    el: ".swiper-pagination",
    dynamicBullets: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});


const swiper3 = new Swiper('.swiper3', {
 // Optional parameters
  direction: 'horizontal',
  loop: true,
  speed: 5000,
　autoplay:{ 
	 delay : 2000,
},

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});


const swiper4 = new Swiper('.swiper4', {
  // Optional parameters
  direction: 'horizontal',
  loop: true,
  speed: 2000,
　autoplay:{ 
	 delay : 5000,
},
	effect: 'fade',
  fadeEffect: {
    crossFade: true
  },

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});